import { defa }         from 'defa-object';
import LogContainer     from 'scripts/defa/log/view-log-container';
import SupportContainer from 'scripts/defa/support/view-support-container';
import Controller       from 'scripts/poppet/controller';

/**
 * defa.controllers.SupportController
 * The controller for the technical support pages.
 * !TODO: Move the support button and frame to the layoutHandler.
 * @version 1.2.0
 */

const channelLayout = Bb.Radio.channel( 'layout' ),
	channelNav    = Bb.Radio.channel( 'nav' );

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	search: apiHost + '/support/search',
};

const SupportController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	/**
	 * Displays a log object for support
	 * @void
	 */
	showLog: function ( type, bid, page ) {
		
		let self    = this,
			modelName,
			modelPath,
			options = {};
		
		// determine logtype based on url
		switch ( type ) {
			
			case 'billing' :
				modelName          = 'Customer';
				modelPath          = defa.models;
				options.customerId = bid;
				break;
			
			case 'device' :
				modelName      = 'Unit';
				modelPath      = defa.models;
				options.unitId = bid;
				break;
			
			case 'user' :
				modelName = 'User';
				modelPath = defa.models;
				options.userId = bid;
				break;
		}
		
		self.requireModel( modelName, modelPath, _.extend( options, {
			bid     : bid,
			self    : self,
			page    : parseInt( page ) - 1,
			type    : type,
			callback: function ( options ) {
					
				let model;
					
				if ( 'user' === type ) {
					model = options[ 'currentUser' ];
				} else {
					model = options[ modelName.toLowerCase() ];
				}
					
				if ( !model.isComplete() ) {
						
					self.listenToOnce( model, 'sync', function () {
						self.attachLogContainer( options );
					} );
					model.fetch();
				} else {
						
					self.attachLogContainer( options );
				}
			},
		} )
		);
	},
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// -- logging events
	
	onLogContainerUpdate: function ( type, id, page ) {
		channelNav.trigger( 'log', [ type, id, page, ] );
	},
	
	// -- support panel events
	
	/**
	 * Triggers when a technical support member attempts to search for something.
	 * @void
	 */
	onSupportContainerSearch: function ( query ) {
		
		let self = this;
		
		$.ajax( {
			 url : api.search,
			 type: 'GET',
			 data: {
				 query: query,
			 },
		 } )
		 .done( function ( response ) {
			
			 // if empty, make it an empty array.
			 if ( !_.isArray( response ) ) {
				 response = [];
			 }
			
			 // reset the ser
			 let ser = channel.request( 'ser' );
			 self.listenToOnce( ser, 'reset', self.onSerReset );
			
			 ser.reset( response );
		 } );
	},
	
	/**
	 * Triggers when a user tries to open a search result.
	 * @param {int}    id    The id of the object to view.
	 * @param {string} type  The class of the object to view.
	 * @void
	 */
	onSupportContainerOpen: function ( id, type ) {
		
		let path = '';
		
		switch ( type ) {
			
			case 'customer' :
				path = 'customer:update';
				break;
			
			case 'unit' :
				path = 'unit:control:overview';
				break;
			
			default :
				path = type + ':panel';
				break;
		}
		
		channelNav.trigger( path, [ id, ] );
	},
	
	/**
	 * Triggers when the support layout requests to initialize a migration.
	 * @param {int} id  The id of the object to view.
	 * @void
	 */
	onSupportContainerMigrate: function ( id ) {
		channelNav.trigger( 'legacy:migrate:id', [ id, ] );
	},
	
	/**
	 * Triggers when the support layout requests to view an installers installed units
	 * @param {int} id  The id of the object to view.
	 * @void
	 */
	onSupportContainerInstalled: function ( id ) {
		channelNav.trigger( 'unit:installed:selected', [ id, 1, ] );
	},
	
	/**
	 * Triggers when the support layout requests to view a log.
	 * @param {int}    id    The id of the object to view.
	 * @param {string} type  The type of object to view.
	 * @void
	 */
	onSupportContainerLog: function ( id, type ) {
		channelNav.trigger( 'log', [ type, id, 1, ] );
	},
	
	/**
	 * Triggers when a SER object resets.
	 * @void
	 */
	onSerReset: function ( collection ) {
		this.supportContainer.attachResponse();
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	// -- logging functions
	
	/**
	 * Creates a new log layout or updates an existing one.
	 * @void
	 */
	attachLogContainer: function ( options ) {
		
		this.logContainer = new LogContainer( options );
		channelLayout.request( 'root' ).showChildView( 'main', this.logContainer );
	},
	
	// -- support panel functions
	
	/**
	 * Creates the support layout and attaches it to the DOM.
	 * @void
	 */
	attachSupportContainer: function ( layout ) {
		
		this.supportContainer = new SupportContainer();
		
		this.listenTo( this.supportContainer, 'search', this.onSupportContainerSearch );
		this.listenTo( this.supportContainer, 'open', this.onSupportContainerOpen );
		this.listenTo( this.supportContainer, 'migrate', this.onSupportContainerMigrate );
		this.listenTo( this.supportContainer, 'installed', this.onSupportContainerInstalled );
		this.listenTo( this.supportContainer, 'log', this.onSupportContainerLog );
		
		channelLayout.request( 'root' ).showChildView( 'support', this.supportContainer );
	},
	
} );

export default SupportController;